import displayNum from "@/utils/displayNum";
import { memo, useMemo, useRef } from "react";
import { Case, Else, If, Switch, Then, When } from "react-if";
// import styles from "./label.module.less";
import HBAvatar from "@/components/Avatar";
import OperationButton, {
  followType,
} from "@/components/FollowButton/operationButton";
import HBIcon from "@/components/HBIcon";
import { useLogin } from "@/components/LoginModal";
import { MuseTag } from "@/components/Muse";
import UserCardPopover from "@/components/UserCard/Popover";
import useAppStore from "@/context/store";
import { followUser, unfollowUser } from "@/services";
import { useHover } from "ahooks";
import { Button, Tooltip } from "antd";
import classNames from "classnames";
import dayjs from "dayjs";
import styles from "./index.module.less";

function useUserVm(pin, setPin) {
  const { config, user } = useAppStore(({ config, user }) => ({
    config,
    user,
  }));
  const nameRef = useRef();
  const isHovering = useHover(nameRef);

  const { login } = useLogin();
  const onToggleFollowUser = async () => {
    if (!user) {
      const result = await login({
        source_location: "用户关注",
      });
      if (!result) {
        return;
      }
    }

    if (pin?.following) {
      const result = await unfollowUser(pin.user?.urlname);
      if (!result.err) {
        setPin({
          ...pin,
          following: false,
          follower_count: pin.follower_count - 1,
          board: {
            ...pin.board,
            following: false,
            user_following: followType.independent,
          },
        });
      }
    } else {
      const result = await followUser(pin.user?.urlname);
      if (!result.err) {
        setPin({
          ...pin,
          following: true,
          follower_count: pin.follower_count + 1,
          board: {
            ...pin.board,
            following: true,
            user_following: followType.unIndependent,
          },
        });
      }
    }
  };
  const isOfficial = useMemo(() => {
    return config?.officialUsers?.split(",").includes(pin?.user?.urlname);
  }, [pin, config]);

  return {
    onToggleFollowUser,
    isOfficial,
    isHovering,
    nameRef,
    user,
  };
}

function User({ pin, setPin }) {
  const { onToggleFollowUser, isOfficial, isHovering, nameRef, user } =
    useUserVm(pin, setPin);

  return (
    <div className={styles.user}>
      <div className={styles.base}>
        <div
          className={styles.left}
          data-gd-click="button_click"
          data-button-name="去个人页"
          data-content-id={pin?.pin_id}
          data-board-id={pin?.board_id}
        >
          <a
            className={classNames(styles.avatar, {
              [styles.hover]: isHovering,
            })}
            href={`/user/${pin?.user?.urlname}`}
            target="_blank"
            data-gd-click="button_click"
            data-button-name="采集用户"
          >
            <When condition={pin?.user}>
              <HBAvatar user={pin?.user} size={32} shape="circle" />
            </When>
          </a>
        </div>
        <div className={styles.middle}>
          <a
            className={styles.title}
            href={`/user/${pin?.user?.urlname}`}
            target="_blank"
            data-gd-click="button_click"
            data-button-name="采集用户"
            data-content-id={pin?.pin_id}
            data-board-id={pin?.board_id}
          >
            <div className={styles.name} ref={nameRef}>
              {pin?.user?.username}
            </div>
            <When condition={isOfficial}>
              <span className={styles.official} title="花瓣官方"></span>
            </When>
            <When condition={pin?.user?.extra?.is_museuser}>
              <MuseTag user={pin?.user} />
            </When>
          </a>
          <div className={styles.num}>
            {displayNum(pin?.follower_count) || 0}粉丝 ·{" "}
            {displayNum(pin?.pin_count) || 0}
            采集
          </div>
        </div>
        <div className={styles.right}>
          <When condition={user?.user_id !== pin?.user_id}>
            <If condition={pin?.following}>
              <Then>
                <OperationButton
                  type="text"
                  className={styles.operationButton}
                  onClick={onToggleFollowUser}
                  data-gd-click="button_click"
                  data-button-name="取消关注Ta"
                  userInfo={pin?.user}
                ></OperationButton>
              </Then>
              <Else>
                <Button
                  onClick={onToggleFollowUser}
                  data-gd-click="button_click"
                  data-button-name="关注Ta"
                >
                  关注Ta
                </Button>
              </Else>
            </If>
          </When>
        </div>
      </div>
      <div className={styles.more}>
        <When condition={pin?.created_at}>
          <div className={styles.time}>
            <If condition={pin?.via_user_id}>
              <Then>
                <span
                  title={
                    pin?.created_at &&
                    new Date(pin?.created_at * 1000)?.toString()
                  }
                >
                  {`${dayjs(pin?.created_at * 1000).format(
                    "YYYY/MM/DD"
                  )} 转采自`}
                </span>
                <a
                  target="_blank"
                  href={`/user/${pin?.via_user?.urlname}`}
                  title={pin?.via_user?.username}
                  data-button-name="转采自用户"
                  data-gd-click="button_click"
                >
                  {pin?.via_user?.username}
                </a>
              </Then>
              <Else>
                <span
                  title={
                    pin?.created_at &&
                    new Date(pin?.created_at * 1000)?.toString()
                  }
                >
                  {`${dayjs(pin?.created_at * 1000).format("YYYY/MM/DD")}`}
                </span>
                <When condition={pin?.via_client}>
                  <If
                    condition={
                      pin?.via_client?.via_id === 95 ||
                      pin?.via_client?.via_id === 7
                    }
                  >
                    <Then>
                      <span className={styles.nbsp}>通过</span>
                      <Tooltip
                        title="用插件可边浏览网页边采集图片"
                        placement="bottom"
                      >
                        <a
                          target="_blank"
                          href={
                            pin?.via_client?.client_link
                              ? pin?.via_client?.client_link
                              : null
                          }
                          rel="noreferrer"
                          title={pin?.via_client?.client_name}
                          data-gd-click="button_click"
                          data-button-name={pin?.via_client?.client_name}
                        >
                          {pin?.via_client?.client_name}
                        </a>
                      </Tooltip>
                    </Then>
                    <Else>
                      <span className={styles.nbsp}>通过</span>
                      <a
                        target="_blank"
                        href={
                          pin?.via_client?.client_link
                            ? pin?.via_client?.client_link
                            : null
                        }
                        rel="noreferrer"
                        title={pin?.via_client?.client_name}
                        data-gd-click="button_click"
                        data-button-name={pin?.via_client?.client_name}
                      >
                        {pin?.via_client?.client_name}
                      </a>
                    </Else>
                  </If>
                </When>
                <span className={styles.nbsp}>采集</span>
              </Else>
            </If>
          </div>
        </When>
        <Switch>
          <Case condition={pin?.text_meta?.creation}>
            <div className={styles.origin}>
              <HBIcon className={styles.icon} type="ic_copyright" />
              <div className={styles.text}>
                来自
                <a
                  href={`/user/${pin?.user?.urlname}`}
                  target="_blank"
                  data-button-name="原始采集用户"
                  data-gd-click="button_click"
                >
                  {pin?.user?.username}
                </a>
                的
                <a
                  href={`/pins/${pin?.pin_id}`}
                  target="_blank"
                  data-button-name="原始采集"
                  data-gd-click="button_click"
                >
                  原创作品
                </a>
              </div>
            </div>
          </Case>
          <Case condition={pin?.original_pin?.text_meta?.creation}>
            <div className={styles.origin}>
              <HBIcon className={styles.icon} type="ic_copyright" />
              <div className={styles.text}>
                来自
                <a
                  href={`/user/${pin?.original_pin?.user?.urlname}`}
                  target="_blank"
                  data-button-name="原始采集用户"
                  data-gd-click="button_click"
                >
                  {pin?.original_pin?.user?.username}
                </a>
                的
                <a
                  href={`/pins/${pin?.original_pin?.pin_id}`}
                  target="_blank"
                  data-button-name="原始采集"
                  data-gd-click="button_click"
                >
                  原创作品
                </a>
              </div>
            </div>
          </Case>
          <Case condition={pin?.original_pin}>
            <div className={styles.origin}>
              <div className={styles.text}>
                来自
                <a
                  href={`/user/${pin?.original_pin?.user?.urlname}`}
                  target="_blank"
                  data-button-name="原始采集用户"
                  data-gd-click="button_click"
                >
                  {pin?.original_pin?.user?.username}
                </a>
                的
                <a
                  href={`/pins/${pin?.original_pin?.pin_id}`}
                  target="_blank"
                  data-button-name="原始采集"
                  data-gd-click="button_click"
                >
                  原始采集
                </a>
              </div>
            </div>
          </Case>
        </Switch>
      </div>
    </div>
  );
}
export default memo(User);

export function User2({
  pin,
  setPin,
}: {
  pin: IPin;
  setPin: (pin: IPin) => void;
}) {
  const { isOfficial, isHovering, nameRef } = useUserVm(pin, setPin);

  const isArt = !!pin?.extra?.art;

  return (
    <div className={styles.user2}>
      <div
        className={styles.left}
        data-gd-click="button_click"
        data-button-name="去个人页"
        data-content-id={pin?.pin_id}
        data-board-id={pin?.board_id}
      >
        <UserCardPopover record={{ ...pin?.user, following: pin?.following }}>
          <a
            className={classNames(styles.avatar, {
              [styles.hover]: isHovering,
            })}
            href={`/user/${pin?.user?.urlname}`}
            target="_blank"
            data-gd-click="button_click"
            data-button-name="采集用户"
          >
            <When condition={!!pin?.user?.avatar || pin?.user?.avatar_url}>
              <HBAvatar user={pin?.user} size={46} shape="circle" withBorder />
            </When>
          </a>
        </UserCardPopover>
      </div>
      <div className={styles.middle}>
        <div className={styles.pinInfo}>
          <UserCardPopover record={{ ...pin?.user, following: pin?.following }}>
            <a
              className={styles.username}
              href={`/user/${pin?.user?.urlname}`}
              target="_blank"
              data-gd-click="button_click"
              data-button-name="采集用户"
              data-content-id={pin?.pin_id}
              data-board-id={pin?.board_id}
              title={pin?.user?.username}
            >
              <div className={styles.name} ref={nameRef}>
                {pin?.user?.username}
              </div>

              {isOfficial && (
                <span className={styles.official} title="花瓣官方"></span>
              )}
              {pin?.user?.extra?.is_museuser && <MuseTag user={pin?.user} />}
            </a>
          </UserCardPopover>

          {!isArt && (
            <>
              <span className={styles.nbsp}>采集至</span>
              <a
                className={styles.board}
                href={`/boards/${pin?.board_id}?viewSource=${pin?.pin_id}`}
                target="_blank"
                data-gd-click="button_click"
                data-button-name="打开采集所在画板"
                title={pin?.board?.title}
              >
                {pin?.board?.title}
              </a>
              <span className={styles.nbsp}>画板</span>
            </>
          )}
        </div>
        <div className={styles.sourceInfo}>
          <If condition={pin?.via_user_id}>
            {/* 转采别人的 */}
            {/* 来自 {原采用户昵称} 的 {原始采集}*/}
            <Then>
              {pin?.original_pin ? (
                <span>
                  <span
                    title={
                      pin?.created_at &&
                      new Date(pin?.created_at * 1000)?.toString()
                    }
                  >
                    {` 于 ${dayjs(pin?.created_at * 1000).format(
                      "YYYY/MM/DD"
                    )}`}
                  </span>
                  <span> 转采，</span>
                  <span>来自 </span>
                  <a
                    href={`/user/${pin?.original_pin?.user?.urlname}`}
                    target="_blank"
                    data-gd-click="button_click"
                    data-button-name="原始采集用户"
                    className={styles.username}
                  >
                    {pin?.original_pin?.user?.username}
                  </a>
                  <span className={styles.nbsp}>的</span>
                  <a
                    href={`/pins/${pin?.original_pin?.pin_id}`}
                    target="_blank"
                    data-gd-click="button_click"
                    data-button-name="原始采集"
                  >
                    原始采集
                  </a>
                </span>
              ) : (
                <span
                  title={
                    pin?.created_at &&
                    new Date(pin?.created_at * 1000)?.toString()
                  }
                >
                  {`${dayjs(pin?.created_at * 1000).format("YYYY/MM/DD")} 转采`}
                </span>
              )}
            </Then>
            <Else>
              {/* 通过 {原采采集方式} 采集自 {原采来源} */}
              {!isArt && (
                <>
                  {pin?.via_client && (
                    <If
                      condition={
                        pin?.via_client?.via_id === 95 ||
                        pin?.via_client?.via_id === 7
                      }
                    >
                      <Then>
                        <span>通过 </span>
                        <Tooltip
                          title="用插件可边浏览网页边采集图片"
                          placement="bottom"
                        >
                          <a
                            target="_blank"
                            href={
                              pin?.via_client?.client_link
                                ? pin?.via_client?.client_link
                                : null
                            }
                            rel="noreferrer"
                            data-gd-click="button_click"
                            data-button-name={pin?.via_client?.client_name}
                          >
                            {pin?.via_client?.client_name}
                          </a>
                        </Tooltip>
                      </Then>
                      <Else>
                        <span>通过 </span>
                        <a
                          target="_blank"
                          href={
                            pin?.via_client?.client_link
                              ? pin?.via_client?.client_link
                              : null
                          }
                          rel="noreferrer"
                          title={pin?.via_client?.client_name}
                          data-gd-click="button_click"
                          data-button-name={pin?.via_client?.client_name}
                        >
                          {pin?.via_client?.client_name}
                        </a>
                      </Else>
                    </If>
                  )}

                  <span
                    title={
                      pin?.created_at &&
                      new Date(pin?.created_at * 1000)?.toString()
                    }
                  >
                    {` 于 ${dayjs(pin?.created_at * 1000).format(
                      "YYYY/MM/DD"
                    )}`}
                  </span>

                  <span className={styles.nbsp}>首次采集</span>
                </>
              )}
              {isArt && (
                <>
                  <span>
                    {dayjs(pin?.created_at * 1000).format("YYYY/MM/DD")}，来自
                  </span>
                  &nbsp;
                  <a
                    target="_blank"
                    href={
                      pin?.via_client?.client_link
                        ? pin?.via_client?.client_link
                        : null
                    }
                    rel="noreferrer"
                    title={pin?.via_client?.client_name}
                    data-gd-click="button_click"
                    data-button-name={pin?.via_client?.client_name}
                  >
                    {pin?.via_client?.client_name}
                  </a>
                </>
              )}
            </Else>
          </If>
        </div>
      </div>
    </div>
  );
}
